var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QInput',_vm._g(_vm._b({ref:"QInput",class:[
    'sai-input',
    { 'sai-input--large': _vm.large, 'sai-input--extra-large': _vm.extraLarge }
  ],attrs:{"dense":_vm.dense,"clearable":_vm.clearable,"hide-bottom-space":_vm.hideBottomSpace,"type":_vm.type,"borderless":"","no-error-icon":""},on:{"input":_vm.updateInput},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(index,name){return {key:name,fn:function(data){return [_vm._t(name,null,null,data)]}}})],null,true)},'QInput',_vm.$attrs,false),_vm.boundListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }